import request from '@/utils/request'

export function fetchList(data) {
  return request({
    url: '/courseItem/List',
    method: 'post',
    data,
  })
}

export function getItem(id) {
  return request({
    url: '/courseItem/Get',
    method: 'post',
    data: { id },
  })
}

export function createItem(data) {
  // console.log('createItem', data)

  return request({
    url: '/courseItem/Create',
    method: 'post',
    data,
  })
}

export function updateItem(data) {
  // console.log('updateItem', data)

  return request({
    url: '/courseItem/Update',
    method: 'post',
    data,
  })
}

export function deleteItem(data) {
  return request({
    url: '/courseItem/Delete',
    method: 'delete',
    data,
  })
}

export function fetchAll() {
  return request({
    url: '/courseItem/List',
    method: 'post',
    data: {
      page: 0,
      limit: 0,
    },
  })
}
